module.exports = __webpack_public_path__ + "img/messenger-ua.4d6d1bfd.png";